<mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header class="section-panel-header">
        <mat-panel-title>
            <app-section-header
                [title]="sectionDescription.title"
                [description]="sectionDescription.description"
            ></app-section-header>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <!-- Upload and Preview Favicon -->
    <h6>Favicon Logo</h6>
    <div class="row align-items-center">
        <div class="col-6">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Favicon URL</mat-label>
                <input id="favicon-url" matInput formControlName="favIconURL" />
                @if (favIconURLControl.invalid && favIconURLControl.hasError('pattern')) {
                    <mat-error>Invalid url</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="col-6 d-flex align-items-center">
            @if (!isUploadingFavIcon) {
                <input
                    class="mb-3"
                    id="favicon-file"
                    type="file"
                    (change)="onFileSelected($event, 'favicon')"
                    accept=".ico,.png"
                />
            } @else {
                <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
            }
        </div>
    </div>
    <mat-divider></mat-divider>
    <div id="main-logo">
        <h6>Main Logo</h6>
        <div class="row align-items-center">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Light Mode Logo URL</mat-label>
                    <input matInput id="logo-light-login" formControlName="mainLogoLightUrl" />
                    @if (mainLogoLightUrlControl.invalid && mainLogoLightUrlControl.hasError('pattern')) {
                        <mat-error>Invalid url</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6 d-flex align-items-center">
                @if (!isUploadingLightLogin) {
                    <input
                        class="mb-3"
                        type="file"
                        id="logo-light-file-login"
                        (change)="onFileSelected($event, 'light')"
                        accept=".svg,.png,.jpg"
                    />
                }
                @if (isUploadingLightLogin) {
                    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
                }
            </div>
        </div>
        <!-- Upload and Preview Dark Logo -->
        <div class="row align-items-center">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Dark Mode Logo URL</mat-label>
                    <input matInput formControlName="mainLogoDarkUrl" id="logo-dark-login" />
                    @if (mainLogoDarkUrlControl.invalid && mainLogoDarkUrlControl.hasError('pattern')) {
                        <mat-error>Invalid url</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6 d-flex align-items-center">
                @if (!isUploadingDarkLogin) {
                    <input
                        class="mb-3"
                        type="file"
                        id="logo-dark-file-login"
                        (change)="onFileSelected($event, 'dark')"
                        accept=".svg,.png,.jpg"
                    />
                }
                @if (isUploadingDarkLogin) {
                    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Logo width</mat-label>
                    <input matInput id="logo-width-login" placeholder="100px" formControlName="mainLogoWidth" />
                    @if (mainLogoWidthControl.invalid && mainLogoWidthControl.hasError('required')) {
                        <mat-error>This field is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Logo height</mat-label>
                    <input matInput placeholder="100px" id="logo-height-login" formControlName="mainLogoHeight" />
                    @if (mainLogoHeightControl.invalid && mainLogoHeightControl.hasError('required')) {
                        <mat-error>This field is required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h6>Main Logo Placement</h6>
                <div class="d-flex gap-3 mt-2">
                    <mat-slide-toggle formControlName="setMainLogoToHeader" color="primary">
                        Use in Header
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="setMainLogoToLogin" color="primary">
                        Use in Login
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
    </div>
    <div id="alternative-logo" [class.disabled-section]="isAlternativeLogoDisabled">
        <h6>Alternative Logo</h6>
        <div class="row align-items-center">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Light Mode Logo URL</mat-label>
                    <input matInput id="logo-light" formControlName="alternativeLogoLightUrl" />
                    @if (alternativeLogoLightUrlControl.invalid && alternativeLogoLightUrlControl.hasError('pattern')) {
                        <mat-error>Invalid url</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6 d-flex align-items-center">
                @if (!isUploadingLightHeader) {
                    <input
                        class="mb-3"
                        type="file"
                        id="logo-light-file"
                        (change)="onFileSelected($event, 'light')"
                        accept=".svg,.png,.jpg"
                        [disabled]="isAlternativeLogoDisabled"
                    />
                }
                @if (isUploadingLightHeader) {
                    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
                }
            </div>
        </div>
        <!-- Upload and Preview Dark Logo -->
        <div class="row align-items-center">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Dark Mode Logo URL</mat-label>
                    <input matInput formControlName="alternativeLogoDarkUrl" id="logo-dark" />
                    @if (alternativeLogoDarkUrlControl.invalid && alternativeLogoDarkUrlControl.hasError('pattern')) {
                        <mat-error>Invalid url</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6 d-flex align-items-center">
                @if (!isUploadingDarkHeader) {
                    <input
                        class="mb-3"
                        type="file"
                        id="logo-dark-file"
                        (change)="onFileSelected($event, 'dark')"
                        accept=".svg,.png,.jpg"
                        [disabled]="isAlternativeLogoDisabled"
                    />
                }
                @if (isUploadingDarkHeader) {
                    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Logo width</mat-label>
                    <input matInput id="logo-width" placeholder="100px" formControlName="alternativeLogoWidth" />
                    @if (alternativeLogoWidthControl.invalid && alternativeLogoWidthControl.hasError('required')) {
                        <mat-error>This field is required</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="col-6">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Logo height</mat-label>
                    <input matInput placeholder="100px" id="logo-height" formControlName="alternativeLogoHeight" />
                    @if (alternativeLogoHeightControl.invalid && alternativeLogoHeightControl.hasError('required')) {
                        <mat-error>This field is required</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h6>Alternative Logo Placement</h6>
                <div class="d-flex gap-3 mt-2">
                    <mat-slide-toggle formControlName="setAlternativeLogoToHeader" color="primary">
                        Use in Header
                    </mat-slide-toggle>
                    <mat-slide-toggle formControlName="setAlternativeLogoToLogin" color="primary">
                        Use in Login
                    </mat-slide-toggle>
                </div>
            </div>
        </div>
    </div>
    <mat-divider></mat-divider>
    <div id="branding-colors">
        <h6>Branding Colors</h6>
        <!-- Independent branding colors section -->
        <app-branding-colors-form formControlName="brandingColors"> </app-branding-colors-form>
    </div>
    <div formGroupName="features">
        <app-header-customization formGroupName="headerConfig"></app-header-customization>
    </div>
</mat-expansion-panel>
